// Client layer (TS-2.5.03) - presentational. The version list doubles as the archive browser
// (BRD section 8.2): each row can open either the version's own artifact detail or a read-only
// snapshot of the roadmap as it stood at that version (decisions.md D-003).
import type { DeckVersionSummary } from "../../api/generated/contracts";
import { formatDate } from "./lib/deckFormat";
import { strings } from "../../strings";

export interface DeckVersionListProps {
  readonly versions: readonly DeckVersionSummary[];
  readonly onOpenDetail: (versionKey: string) => void;
  readonly onOpenSnapshot: (versionKey: string) => void;
}

const S = strings.decks.versions;

export function DeckVersionList({ versions, onOpenDetail, onOpenSnapshot }: DeckVersionListProps) {
  if (versions.length === 0) {
    return <p>{S.empty}</p>;
  }

  return (
    <table className="eg-deck-versions">
      <caption>{S.heading}</caption>
      <thead>
        <tr>
          <th scope="col">{S.columns.title}</th>
          <th scope="col">{S.columns.state}</th>
          <th scope="col">{S.columns.reportDate}</th>
          <th scope="col">{S.columns.publishedBy}</th>
          <th scope="col" />
        </tr>
      </thead>
      <tbody>
        {versions.map((version) => (
          <tr key={version.versionKey}>
            <td>{version.title}</td>
            <td>{S.states[version.state]}</td>
            <td>{formatDate(version.reportDate)}</td>
            <td>{version.publishedByDisplayName ?? "—"}</td>
            <td>
              <button type="button" onClick={() => onOpenDetail(version.versionKey)}>
                {S.viewDetail}
              </button>
              <button type="button" onClick={() => onOpenSnapshot(version.versionKey)}>
                {S.viewSnapshot}
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
